"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryLogsTable = exports.IDBLogsTable = void 0;
const dexie_1 = __importDefault(require("dexie"));
class IDBLogsTable {
    constructor(logs, logFactory) {
        this.logs = logs;
        this.logFactory = logFactory;
    }
    add(item) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.logs.add(item);
        });
    }
    count(sessionUUID) {
        return this.logs.where({ sessionUUID }).count();
    }
    deleteBatch(sessionUUID, batchSize) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.logs.where({ sessionUUID }).limit(batchSize).delete();
        });
    }
    deleteOldLogs(sessionUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const db = this.logs.db;
            return db.transaction('rw', this.logs, () => __awaiter(this, void 0, void 0, function* () {
                const firstEntryKey = (yield this.logs.where({ sessionUUID }).limit(1).primaryKeys())[0];
                const logs = yield this.logs.where({ sessionUUID }).limit(10).toArray();
                if (logs.length <= 1) {
                    return;
                }
                const log = {
                    sessionUUID,
                    data: this.logFactory.createGapLog(logs.map(e => e.data)),
                };
                yield this.logs.update(firstEntryKey, log);
                yield this.logs.where({ sessionUUID }).offset(1).limit(9).delete();
            }));
        });
    }
    getBatch(sessionUUID, batchSize) {
        return this.logs.where({ sessionUUID }).limit(batchSize).toArray();
    }
}
exports.IDBLogsTable = IDBLogsTable;
class InMemoryLogsTable {
    constructor(logFactory, storageLimit) {
        this.logFactory = logFactory;
        this.storageLimit = storageLimit;
        this.data = [];
        this.idCounter = 0;
    }
    getNextID() {
        return this.idCounter++;
    }
    add(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.length >= this.storageLimit) {
                throw new dexie_1.default.QuotaExceededError();
            }
            const id = this.getNextID();
            this.data.push(Object.assign(Object.assign({}, item), { id }));
        });
    }
    count(sessionUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.data.filter(d => d.sessionUUID === sessionUUID).length;
        });
    }
    deleteBatch(sessionUUID, batchSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [];
            let counter = 0;
            for (let i = 0; i < this.data.length; i++) {
                const log = this.data[i];
                if (log.sessionUUID === sessionUUID && counter < batchSize) {
                    counter++;
                }
                else {
                    data.push(log);
                }
            }
            this.data = data;
        });
    }
    deleteOldLogs(_sessionUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const logs = this.data.slice(0, 10);
            if (logs.length <= 1) {
                return;
            }
            this.data[0].data = this.logFactory.createGapLog(logs.map(e => e.data));
            this.data.splice(1, 9);
        });
    }
    getBatch(sessionUUID, batchSize) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.data.filter(d => d.sessionUUID === sessionUUID).slice(0, batchSize);
        });
    }
}
exports.InMemoryLogsTable = InMemoryLogsTable;
